export const PKDDiagnosis = {
  ADPKD        : 'Autosomal Dominant (ADPKD)',
  Unknown      : 'Diagnosis Unknown',
  NotSpecified : 'Not Specified',
};

export const Relationship = {
  Self         : 'Self',
  Parent       : 'Parent/Legal Guardian',
  Other        : 'Other',
  NotSpecified : 'Not Specified',
};

export const PersonRecordType = {
  PersonAttribute : 'person_attribute',
  PersonStudyRole : 'person_study_role',
};

export const PersonStatus = {
  Withdrawn     : 'withdrawn',
  Initialized   : 'ini',
  Enrolled      : 'enrolled',
  Authenticated : 'authenticated',
  Consented     : 'consented',
  Onboarded     : 'onboarded',
};

export const Gender = {
  Male                   : 'male',
  Female                 : 'female',
  'Non binary'           : 'non_binary',
  'Transgender male'     : 'transgender_male',
  'Transgender female'   : 'transgender_female',
  'Prefer not to answer' : 'prefer_not_to_answer',
};

export const SurveyStatus = {
  Completed  : 'completed',
  Incomplete : 'incomplete',
};

export const TaskStatus = {
  Completed  : 'completed',
  Incomplete : 'incomplete',
  Inprogress : 'in_progress',
};

export const TaskTitles = {
  dailySurvey             : 'Daily Survey',
  liverCyst               : 'Experience with Liver Cysts',
  dietLifestyle           : 'Diet and Lifestyle Survey',
  vascularOutcomesGeneral : 'Vascular Outcomes',
  vascularOutcomesFamily  : 'Vascular Outcomes - Family - Intracranial aneurysm',
  vascularOutcomesLowerBody :
    'Vascular Outcomes - Family - Aortic aneurysm of the abdomen/lower body',
  vascularOutcomesUpperBody :
    'Vascular Outcomes - Family - Aortic aneurysm of the chest/upper body',
  healthCareAccess : 'Health Care Access and Utilization',
  familyHistory    : 'Family History Survey',
  ADPKDPDS :
    'Autosomal Dominant Polycystic Kidney Disease - Pain and Discomfort Scale (ADPKD-PDS\u00a9)',
  ADPKDIS :
    'Autosomal Dominant Polycystic Kidney Disease - Impact Scale (ADPKD-IS)',
  coreQuestionnaire     : 'Core Questionnaire',
  clinicalStudiesReport : 'Check out the Clinical Studies Eligibility Report',
  clinicalEligibility   : 'Check out the Clinical Studies Eligibility Report',
  socialDeterminants    : 'Social Determinants of Health',
  patientCenteredSocialDeterminants :
    'Patient-Centered Insights on Treatment Adherence and Social Determinants of Health',
  pulseSurvey : 'Answer our daily PULSE survey',
};

export const StudyRoleId = {
  Participant : 1,
  Caregiver   : 2,
};

export const Questionnaires = {
  CoreQuestionnaire : 'Core Questionnaire',
};

export const SocialMediaURLs = {
  Linkedin : 'https://www.linkedin.com/company/pkd-foundation',
  Facebook : 'https://www.facebook.com/pkdfoundation',
  Twitter :
    'https://twitter.com/PKDFoundation?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor',
  Instagram : 'https://www.instagram.com/pkdfoundation',
};

export const StudyArms = {
  Research : 'Research Registry',
};

export const StudyArmRoles = {
  Participant : 'participant',
};
